import { Block } from '../../models/block';

class LeftMenuSubTotalBlock extends Block {
    getStyles = () => ({
        ...this.styles,
    });
}

export default LeftMenuSubTotalBlock;
